export function matchesLibrarySave(current, action) {
  return Boolean(current && (
    (current.id && current.id === action.meta?.id) ||
    (current.retry_message_id && current.retry_message_id === action.meta?.message_id)
  ));
}
